import { fetchTableActivitiesDemo } from "@/data/demo/table.demo";
import type { DataClient } from "@/types/client.types";
import { fetchCalendarActivitiesDemo } from "../demo/calendar.demo";
import { fetchChartDataDemo } from "../demo/chart.demo";
import { fetchMapActivitiesDemo } from "../demo/map.demo";

export const demoClient: DataClient = {
  fetchTableActivities: fetchTableActivitiesDemo,
  fetchChartData: fetchChartDataDemo,
  fetchCalendarActivities: fetchCalendarActivitiesDemo,
  fetchMapActivities: fetchMapActivitiesDemo,
};
